module.exports = __webpack_public_path__ + "img/middle-pic.bbbace50.png";